var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.
var player;

function onYouTubeIframeAPIReady() {


  var videoElement = document.getElementById('player');
  var videoId = videoElement.getAttribute('data-video-id');


  player = new YT.Player('player', {
    height: '390',
          width: '640',
          videoId: videoId,
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });
};

// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
    window.addEventListener('scroll', checkScroll, false);
    window.addEventListener('resize', checkScroll, false);

    //check at least once so you don't have to wait for scrolling for the    video to start
    window.addEventListener('load', checkScroll, false);
};


function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING) {
      //console.log("event played");
    } else {
      //console.log("event paused");
    }
};

function stopVideo() {
    player.stopVideo();
};

function playVideo() {
  player.playVideo();
};

function pauseVideo() {
  player.pauseVideo();
};

function muteVideo() {
  player.mute();
};


$(window).scroll(function() {
    var top_of_element = $(".video-container").offset().top;
    var bottom_of_element = $(".video-container").offset().top + $(".video-container").outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();
 

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        playVideo();
        muteVideo();

    } else {
      pauseVideo();

    }
});